(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var PRICE = 149.99, MAX = 10, qty = 1;
  var TRACK = (function () {
    var k = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'cmc_vid', 'cmc_adid'], q = new URLSearchParams(location.search), t = {};
    try { t = JSON.parse(sessionStorage.getItem('ks_track') || '{}'); } catch (e) {}
    k.forEach(function (n) { var v = q.get(n); if (v && v.indexOf('[') !== 0) t[n] = v.slice(0, 250); });
    try { sessionStorage.setItem('ks_track', JSON.stringify(t)); } catch (e) {}
    return t;
  })();
  function eur(n) { return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function cartUrl() {
    if (window.KS_CHECKOUT) return window.KS_CHECKOUT;
    var v = window.KS_VARIANTS; if (!v || !v.one) return null;
    var u = new URLSearchParams(), cm = window.clickmagick_cmc;
    u.set('attributes[ad_landing_page]', 'klarsyn-de-pdp');
    Object.keys(TRACK).forEach(function (n) { u.set('attributes[ad_' + n + ']', TRACK[n]); });
    if (cm && cm.vid) u.set('attributes[ad_cm_visitor]', cm.vid);
    var items = v.one + ':' + qty + (v.gift ? ',' + v.gift + ':' + qty : '');
    return (window.KS_CART || '/cart') + '/' + items + '?' + u.toString();
  }
  function render() {
    $('[data-qty]').textContent = qty;
    $('[data-total]').textContent = eur(PRICE * qty);
    $('[data-s-price]').textContent = eur(PRICE * qty);
    $('.step [data-step="-1"]').disabled = qty <= 1;
    $('.step [data-step="1"]').disabled = qty >= MAX;
  }
  $$('.step button').forEach(function (b) { b.addEventListener('click', function () { qty = Math.min(MAX, Math.max(1, qty + +b.getAttribute('data-step'))); render(); }); });
  function buy(e) {
    e.preventDefault(); var u = cartUrl();
    if (!u) { var t = $('[data-toast]'); t.textContent = 'Vorschau: Der Checkout öffnet im Live-Shop.'; t.hidden = false; setTimeout(function () { t.hidden = true; }, 2500); return; }
    location.href = u;
  }
  $('[data-buy]').addEventListener('click', buy);
  $('[data-buy2]').addEventListener('click', buy);
  var main = $('[data-main]');
  $$('.thumbs button').forEach(function (b) { b.addEventListener('click', function () { main.src = b.getAttribute('data-src'); $$('.thumbs button').forEach(function (x) { x.classList.toggle('on', x === b); }); }); });
  var st = $('[data-sticky]'), atc = $('[data-buy]');
  if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (x) { st.classList.toggle('show', !x.isIntersecting && x.boundingClientRect.top < 0); }); }).observe(atc);
  /* rotating announcement + mobile menu */
  var ann = $('[data-ann]'), ai = 0, msgs = ann ? [ann.innerHTML, '<img class="ai" src="' + ann.getAttribute('data-gift') + '" alt="">24 Extra-Pads gratis'] : [];
  if (ann) setInterval(function () { ai = (ai + 1) % msgs.length; ann.innerHTML = msgs[ai]; }, 3500);
  var bg = $('.burger'), nav = $('[data-nav]');
  if (bg && nav) { bg.addEventListener('click', function () { nav.classList.toggle('open'); bg.setAttribute('aria-expanded', nav.classList.contains('open')); });
    $$('a', nav).forEach(function (a) { a.addEventListener('click', function () { nav.classList.remove('open'); }); }); }
  render();
})();
